<template>
    <div>
        <v-app-bar app flat fixed color="white" light extension-height="64">
            <div>
                <v-img alt="NEW Energyview" class="xlogo shrink mr-2" contain
                    :src="require('@/assets/NEW_Energie_Logo_RBG_2023.svg')" />
            </div>
            <v-spacer></v-spacer>
            <div v-if="getMode() == 'test'" style="background-color: red;">TEST</div>
            <div class="mr-4 d-flex flex-column align-end">
                <div>{{ getUsermailAddr }}</div>
                <div v-if="getUserLevelName" class="text-caption grey--text text--darken-1" style="line-height: 1;">{{ getUserLevelName }}</div>
            </div>
            <div id="loginnew-dropdown"></div>
            <template #extension>
                <v-toolbar color="white" flat light class="nav-toolbar">
                    <v-container>
                        <div class="nav-links">
                            <v-btn text v-for="link in Object.keys(navBarLinks)" :key="link"
                                class="nav-link-btn"
                                @click="onClickMenuCategory(link)">{{ link }}</v-btn>
                        </div>
                    </v-container>
                </v-toolbar>

            </template>
        </v-app-bar>
    </div>
</template>

<script>
export default {
    name: "AppBar",
    data() {
        return {
            links: [],
            currentFirma: {},
            absolute: false,
            overlay: false,
            userLevelName: "",
        }
    },
    methods: {
        onClickMenuCategory(category) {
            // Wenn das Overlay bereits offen ist und die gleiche Kategorie geklickt wird → schließen
            // Wenn eine andere Kategorie geklickt wird → Kategorie wechseln (offen lassen)
            // Wenn das Overlay geschlossen ist → öffnen und Kategorie setzen
            if (this.$store.state.main.menuoverlay && this.$store.state.main.currentCategory === category) {
                this.$store.state.main.menuoverlay = false
            } else {
                this.$store.state.main.currentCategory = category
                this.$store.state.main.menuoverlay = true
            }

        },
        setCurrentFirma(firma) {
            this.$store.dispatch("switchFirma", firma)
        },
        getMode() {
            return process.env.NODE_ENV
        },
        async resolveUserLevelName() {
            const userprofile = this.$store.state.auth.userprofile
            if (!userprofile || userprofile.level === undefined || userprofile.level === null) {
                this.userLevelName = ""
                return
            }
            const rolesState = this.$store.state.roles
            let levelToRoles = rolesState && rolesState.levelToRoles
            if (!levelToRoles || Object.keys(levelToRoles).length === 0) {
                try {
                    await this.$store.dispatch("getAllRoles")
                } catch (err) {
                    console.warn("getAllRoles failed", err)
                }
                levelToRoles = this.$store.state.roles && this.$store.state.roles.levelToRoles
            }
            this.userLevelName = (levelToRoles && levelToRoles[userprofile.level]) || ""
        }
    },
    computed: {
        navBarLinks() {
            let routes = this.$router.options.routes
            let categories = {}
            let permissions=this.$store.state.auth.authClaims.permissions
            for (let route of routes) {
                if (route.meta && route.meta.showInDrawer && route.meta.showInDrawer === true && route.meta.category != undefined) {
                    if (!route.meta.requiresAuth || (route.meta.requiresAuth && this.$store.state.auth && this.$store.state.auth.isSignedIn)) {
                        if (permissions[route.meta.permission] === true) {
                            if (categories[route.meta.category] == undefined) {
                                categories[route.meta.category] = []
                            }
                            categories[route.meta.category].push({
                                link: route.path,
                                title: route.meta.title
                            })
                        }
                    }
                }
            }
            if (!this.$store.state.auth || !this.$store.state.auth.userprofile || !this.$store.state.auth.userprofile.email) {
                return []
            } 

            return categories
        },
        isSignedIn() {
            return this.$store.state.auth.isSignedIn
        },
        isFirmenArray() {
            if (!this.$store.state.auth.firmen) { return }
            return this.$store.state.auth.firmen.length > 1 ? true : false
        },
        getCurrentFirma() {
            return this.$store.state.auth.currentFirma ? this.$store.state.auth.currentFirma : {}
        },
        getCurrentFirmaName() {
            return this.$store.state.auth.currentFirma ? this.$store.state.auth.currentFirma.name : ""
        },
        getFirmenList() {
            return this.$store.state.auth.firmen
        },
        getUsermailAddr() {
            return this.$store.state.auth.userprofile ? this.$store.state.auth.userprofile.email : ""
        },
        getUserLevelName() {
            return this.userLevelName
        }
    },
    watch: {
        "$store.state.auth.userprofile": {
            immediate: true,
            handler(profile) {
                if (profile && profile.level !== undefined && profile.level !== null) {
                    this.resolveUserLevelName()
                }
            }
        },
        getFirmenList() {
            if (!this.$store.state.auth.currentFirma) {
                this.setCurrentFirma(this.$store.state.auth.firmen[0])
            }
            this.currentFirma = this.$store.state.auth.currentFirma
        }
    },
    mounted() {
        console.log("mode",this.getMode())
    }
}
</script>

<style>
/* Profiltext */
#loginnew-dropdown .login-new-avatar span {
    display: none;
}

header.v-app-bar {
    contain: unset;
    transform: none !important;
    overflow: visible;
    box-shadow: 0 2px 8px rgba(34, 38, 47, 0.08) !important;
}

.xlogo {
    display: inline-block;
    width: auto;
    height: 45px;
}

/* Navigation Buttons in der Appbar */
header.v-app-bar .v-toolbar__extension .v-btn {
    font-family: 'Geometria', Arial, Helvetica, sans-serif !important;
    font-weight: 500 !important;
    color: #22262f !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-size: 16px !important;
    border-radius: 5px !important;
}

header.v-app-bar .v-toolbar__extension .v-btn:hover {
    color: #b40055 !important;
}

/* User-Info Text */
header.v-app-bar .mr-4 {
    font-family: 'Geometria', Arial, Helvetica, sans-serif;
    font-size: 14px;
    color: #22262f;
}

/* Navigation bar bottom border */
.nav-toolbar {
    border-bottom: 2px solid #f2f2f3 !important;
}

.nav-links {
    display: flex;
    gap: 5px;
}

.nav-link-btn {
    position: relative;
    padding: 8px 16px !important;
}

.nav-link-btn::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background-color: #b40055;
    transition: all 0.25s ease;
    transform: translateX(-50%);
}

.nav-link-btn:hover::after {
    width: 80%;
}

</style>